<template>
  <div class="mt-6" :class="{ 'container-full-width': isMdView }">
    <v2-accordion-item :isActive="isActive">
      <template v-slot:label>
        <div class="flex justify-between" :class="[isSmView ? 'w-11/12' : 'w-full']">
          <div class="flex items-center" :class="[isMdView ? 'w-9/12' : 'w-full']">
            <div
              v-if="isStatusPending"
              class="flex place-items-center place-content-center mr-3 bg-v2-status-yellow w-25px h-25px rounded-full"
            >
              <v2-awesome-icon name="eye" fill="white" class="custom" />
            </div>
            <div
              v-if="isStatusRejected"
              class="flex place-items-center place-content-center mr-3 bg-v2-status-red w-25px h-25px rounded-full"
            >
              <v2-awesome-icon name="times" fill="white" class="custom" />
            </div>
            <div
              v-if="isStatusApproved"
              class="flex place-items-center place-content-center mr-3 bg-v2-status-green w-25px h-25px rounded-full"
            >
              <v2-awesome-icon name="check" fill="white" class="custom" />
            </div>
            <div
              v-if="isStatusDraft"
              class="flex place-items-center place-content-center mr-3 bg-v2-grey-light w-25px h-25px rounded-full"
            >
              <v2-awesome-icon name="eye-slash" fill="white" class="custom" />
            </div>
            <h3 :class="{ truncate: isMdView, 'w-10/12': isSmView }" v-if="!isEditDialogActive">
              {{ fileApproval.name }}
            </h3>
            <v2-textfield
              @click.native.stop
              withoutFormError
              small
              v-if="isEditDialogActive"
              :placeholder="$t('fileapproval.placeholders.title')"
              v-model="fileApproval.name"
              v-validate="'required|regex:^[0-9]+'"
              name="title"
              @keyup.native.enter="updateFileApproval"
            ></v2-textfield>
          </div>
          <div class="flex items-end mr-4">
            <v2-button
              :title="$t('fileapproval.buttons.editTitle')"
              class="ml-2"
              ghostProgress
              outline
              icon
              sm
              v-if="isEditable && !isEditDialogActive"
              @click.native.stop="isEditDialogActive = true"
            >
              <v2-icon :data="require('@icon/Icon=edit-2.svg')" color="rgba(51, 59, 149, 1)" class="custom"></v2-icon>
            </v2-button>
            <v2-button
              :active="fileApproval.name && fileApproval.name.length > 0"
              v-show="isEditable && isEditDialogActive"
              :title="$t('fileapproval.buttons.saveTitle')"
              class="ml-2"
              ghostProgress
              outline
              icon
              sm
              @click.native.stop="updateFileApproval"
            >
              <v2-icon :data="require('@icon/Icon=check.svg')" color="rgba(51, 59, 149, 1)" class="custom"></v2-icon>
            </v2-button>
            <v2-button
              :title="$t('fileapproval.buttons.deleteFileApproval')"
              ghostProgress
              outline
              icon
              iconWarning
              sm
              class="ml-2"
              v-show="isRemovable"
              @click.native.stop="deleteFileApproval"
            >
              <v2-icon :data="require('@icon/Icon=trash.svg')" color="rgba(51, 59, 149, 1)" class="custom"></v2-icon>
            </v2-button>
          </div>
        </div>
      </template>
      <template v-slot:box>
        <div
          v-if="
            fileApproval &&
            fileApproval.versions[0] &&
            (fileApproval.versions[0].rejected_at ||
              (fileApproval.versions[0].revoked_at &&
                !fileApproval.versions[0].rejected_at &&
                !fileApproval.versions[0].approved_at))
          "
          class="w-full flex justify-end px-6 mb-3"
        >
          <a @click="addNewVersion()" class="primary">
            {{ $t("fileapproval.buttons.newVersion") }}
          </a>
        </div>
        <v2-row noSpace>
          <v2-col col12 noSpace noSpaceX>
            <div v-if="fileApproval.versions && fileApproval.versions.length > 0">
              <v2-file-approval-version
                v-for="fileApprovalVersion in fileApproval.versions"
                :key="fileApprovalVersion.uid"
                :file-approval-version="fileApprovalVersion"
                :file-approval-uid="fileApproval.uid"
                :project-uid="projectUid"
                :timezone="timezone"
                :locale="locale"
                @versionRevoked="addNewVersion"
              ></v2-file-approval-version>
            </div>

            <div v-if="!fileApproval.versions || fileApproval.versions.length === 0" class="pt-4">
              <div class="flex justify-end">
                <a @click="addNewVersion()" class="primary absolute top-4 right-4">
                  {{ $t("fileapproval.buttons.newVersion") }}
                </a>
              </div>
            </div>
          </v2-col>
        </v2-row>

        <v2-row v-if="!fileApproval.versions || fileApproval.versions.length === 0" noSpace>
          <v2-col col12 noSpace noSpaceX>
            <!-- {{ $t('fileapproval.labels.noFilesInApprovalVersion')}} -->
            <div class="text-center text-gray-500 mt-8 mb-8">
              {{ $t("fileapproval.labels.noVersions") }}
            </div>
          </v2-col>
        </v2-row>
      </template>
    </v2-accordion-item>
  </div>
</template>

<script>
import { mapActions } from "vuex";
import globalMixin from "@/mixins/global.js";
import FileApprovalVersion from "@/views/partials/fileApproval/FileApprovalVersion";

export default {
  name: "FileApproval",
  components: {
    "v2-file-approval-version": FileApprovalVersion,
  },
  mixins: [globalMixin],
  props: {
    projectUid: {
      type: String,
      required: true,
    },
    fileApproval: {
      type: Object,
      required: true,
    },
    timezone: {
      type: String,
      required: true,
    },
    locale: {
      type: String,
      required: true,
    },
    isActive: {
      type: Boolean,
      default: false,
    },
  },
  data() {
    return {
      createNewVersion: false,
      isEditDialogActive: false,
    };
  },
  created() {
    if (!this.hasVersions) this.addNewVersion();
  },
  computed: {
    hasVersions() {
      return this.fileApproval.versions && this.fileApproval.versions.length > 0;
    },
    isStatusDraft() {
      if (!this.hasVersions) {
        return true;
      }

      if (!this.fileApproval.versions[0].issued_at) {
        return true;
      }

      return false;
    },
    isStatusPending() {
      if (!this.hasVersions) {
        return false;
      }

      if (
        this.fileApproval.versions[0].issued_at &&
        !this.fileApproval.versions[0].revoked_at &&
        !this.fileApproval.versions[0].rejected_at &&
        !this.fileApproval.versions[0].approved_at
      ) {
        return true;
      }
      return false;
    },
    isStatusRevoked() {
      if (!this.hasVersions) {
        return false;
      }

      if (
        this.fileApproval.versions[0].revoked_at &&
        !this.fileApproval.versions[0].rejected_at &&
        !this.fileApproval.versions[0].approved_at
      ) {
        return true;
      }

      return false;
    },
    isStatusApproved() {
      if (!this.hasVersions) {
        return false;
      }

      if (this.fileApproval.versions[0].approved_at) {
        return true;
      }
      return false;
    },
    isStatusRejected() {
      if (!this.hasVersions) {
        return false;
      }

      if (this.fileApproval.versions[0].rejected_at) {
        return true;
      }

      return false;
    },
    isRemovable() {
      let vm = this;

      if (!vm.fileApproval.versions) {
        return true;
      }

      if (vm.fileApproval.versions.length === 0) {
        return true;
      }

      return false;
    },
    isEditable() {
      // at the moment is a file approval always editable because the user can only edit the name
      return true;
    },
  },
  methods: {
    ...mapActions(["fileApprovalApiRequest"]),

    addNewVersion() {
      // this event can only triggered from the UI if no
      // version exists and if we create the first version

      let vm = this;

      const payload = {
        apiMethod: "fileApprovalVersionCreate",
        params: {
          project: vm.projectUid,
          fileApproval: vm.fileApproval.uid,
        },
        data: {},
      };

      vm.fileApprovalApiRequest(payload)
        .then((fileApprovalVersion) => {
          vm.$snotify.success(vm.$t("fileapproval.toasts.createVersion.success"), vm.$t("toasts.success"), {
            icon: vm.$successIcon,
          });
          console.log("new file approval version created", fileApprovalVersion);
          vm.$eventbus.$emit("fileApprovalListReloadEvent");
        })
        .catch((err) => {
          vm.$snotify.error(vm.$t("fileapproval.toasts.createVersion.error"), vm.$t("toasts.error"), {
            timeout: 0,
            icon: vm.$errorIcon,
          });
          console.log("error: ", err);
        });
    },

    resetFileApprovalFormAndGoBack() {
      let vm = this;

      vm.fileApproval.title = "";
      vm.isEditDialogActive = false;
    },

    updateFileApproval() {
      let vm = this;

      const payload = {
        apiMethod: "fileApprovalUpdate",
        params: {
          project: vm.projectUid,
          fileApproval: vm.fileApproval.uid,
        },
        data: {
          name: vm.fileApproval.name,
        },
      };

      vm.fileApprovalApiRequest(payload)
        .then((fileApproval) => {
          vm.$snotify.success(vm.$t("fileapproval.toasts.updateFileApproval.success"), vm.$t("toasts.success"), {
            icon: vm.$successIcon,
          });
          console.log("update file approval", fileApproval);
          vm.$eventbus.$emit("fileApprovalListReloadEvent");

          vm.isEditDialogActive = false;
        })
        .catch((err) => {
          vm.$snotify.error(vm.$t("fileapproval.toasts.updateFileApproval.error"), vm.$t("toasts.error"), {
            timeout: 0,
            icon: vm.$errorIcon,
          });
          console.log("error: ", err);
        });
    },

    deleteFileApproval() {
      let vm = this;

      let payload = {
        apiMethod: "fileApprovalDelete",
        params: {
          project: vm.projectUid,
          fileApproval: vm.fileApproval.uid,
        },
      };

      vm.fileApprovalApiRequest(payload)
        .then(() => {
          vm.$snotify.success(vm.$t("fileapproval.toasts.deleteFileApproval.success"), vm.$t("toasts.success"), {
            icon: vm.$successIcon,
          });
          console.log("file approval deleted");
          vm.$eventbus.$emit("fileApprovalListReloadEvent");
        })
        .catch((err) => {
          vm.$snotify.error(vm.$t("fileapproval.toasts.deleteFileApproval.error"), vm.$t("toasts.error"), {
            timeout: 0,
            icon: vm.$errorIcon,
          });
          console.log("error: ", err);
        });
    },
  },
};
</script>
